import React from "react";
import { CURRENCY_LOCALE, FIELD_TYPE } from "types/enums";
const { INPUT, SELECT, DATE, CURRENCY, CURRENCY_NEGATIVE } = FIELD_TYPE;
import icons from "assets/icons";
import "./TabPay.scss";
import { DataFormField } from "types/models/input-field-type";
import { formatToCurrencyType } from "helper/common";

const TabPayConfig = (onChange?: any, minCurrency?: number) => {
  const dataFieldPayChild: DataFormField[] = [
    {
      type: CURRENCY,
      name: "tongChiPhiDotDieuTri",
      label: "Tổng thanh toán",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
    },
    {
      type: CURRENCY,
      name: "tongTienBaoHiemYTe",
      label: "Bảo hiểm trả",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
    },

    {
      type: CURRENCY,
      name: "tongTienBenhNhanCungChiTra",
      label: "BN cùng chi trả",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
    },
    {
      type: CURRENCY,
      name: "tongTienBenhNhanChiTra",
      label: "BN chi trả",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
    },
    {
      type: CURRENCY,
      label: "Tổng miễn giảm",
      name: "tongMienGiamThanhToan",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
      onChange: onChange,
    },
    {
      type: CURRENCY,
      label: "BN đã trả",
      name: "benhNhanDaTra",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
    },
    {
      type: CURRENCY,
      label: "Số dư BN",
      name: "soDuBenhNhan",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
    },
    {
      type: CURRENCY,
      label: "BN phải trả",
      name: "benhNhanPhaiTra",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
    },
    {
      type: CURRENCY,
      label: "Tổng tiền đã thực hiện miễn giảm",
      name: "tongTienDaThucHienMienGiam",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
      onChange: onChange,
    },

    {
      type: CURRENCY,
      name: "tongTienNguoiBenhTamUng",
      label: "BN đã tạm ứng",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
    },
    {
      type: CURRENCY,
      label: "Tổng tiền miễn giảm CT ưu đãi",
      name: "tongTienMienGiamChuongTrinhUuDai",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
    },
  ];
  return dataFieldPayChild;
};

const TabPayConfigNoiTru = (onChange?: any, minCurrency?: number) => {
  const dataFieldPayChild: DataFormField[] = [
    {
      type: CURRENCY,
      name: "tongChiPhiDotDieuTri",
      label: "Tổng thanh toán",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
    },
    {
      type: CURRENCY,
      name: "tongTienBaoHiemYTe",
      label: "Bảo hiểm trả",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
    },

    {
      type: CURRENCY,
      name: "tongTienBenhNhanCungChiTra",
      label: "BN cùng chi trả",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
    },
    {
      type: CURRENCY_NEGATIVE,
      name: "tongTienBenhNhanChiTra",
      label: "BN chi trả",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
    },
    {
      type: CURRENCY_NEGATIVE,
      label: "Tổng miễn giảm",
      name: "tongMienGiamThanhToan",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      // disable: true,
      onChange: onChange,
    },
    {
      type: CURRENCY,
      label: "BN đã trả",
      name: "benhNhanDaTra",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
    },
    {
      type: CURRENCY,
      label: "Số dư BN",
      name: "soDuBenhNhan",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
    },
    {
      type: CURRENCY,
      label: "BN phải trả",
      name: "benhNhanPhaiTra",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
    },
    {
      type: CURRENCY,
      label: "Tổng tiền đã thực hiện miễn giảm",
      name: "tongTienDaThucHienMienGiam",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
      onChange: onChange,
    },
    {
      type: CURRENCY,
      name: "tongTienNguoiBenhTamUng",
      label: "BN đã tạm ứng",
      placeholder: "-",
      css: { sm: 24, md: 6, lg: 6 },
      disable: true,
    },
  ];
  return dataFieldPayChild;
};

export { TabPayConfig, TabPayConfigNoiTru };
